const axios = require('axios').default;
const getCustomizedUrl = (url) => {
    if (url) {
        if (url.length === 1) {
            return url[0];
        } else {
            let requestUrl = url[0];
            const idList = url[1];
            idList.forEach(id => requestUrl = requestUrl.replace('${id}', id));
            return requestUrl;
        }
    } else {
        return '';
    }
};

class ApiSvc {
    static request(url, requestMethod, requestData) {
        const requestUrl = `https://${process.env.VUE_APP_BASE_URL}/gsc/hp-gsc3${getCustomizedUrl(url)}?pdfMode=false&includeDescr=true&lang=en&country=US&latest=true`;
        const config = {
            method: requestMethod,
            url: requestUrl,
            data: requestData,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'X-HTTP-Method-Override': "GET",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, PUT,POST, DELETE,OPTIONS'
            },
        };
        const axiosInstance = axios.create(config);  

        axiosInstance.interceptors.response.use(response => {
            return response;
        }, error => {
            // const errorHandler = new ErrorHandler(error.response.data.code);
            // errorHandler.showMessage();
            return Promise.reject(error);
        });

        return axiosInstance.request(config);
    }

    static requestForPdf(url, requestMethod, requestData) {
        const requestUrl = `https://${process.env.VUE_APP_BASE_URL}/gsc/hp-gsc3${getCustomizedUrl(url)}?pdfMode=true&includeDescr=true&lang=en&country=US&latest=true`;
        const config = {
            method: requestMethod,
            url: requestUrl,
            data: requestData,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Accept': 'application/json',
                'X-HTTP-Method-Override': "GET",
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, PUT,POST, DELETE,OPTIONS'
            },
        };
        const axiosInstance = axios.create(config);

        axiosInstance.interceptors.response.use(response => {
            return response;
        }, error => {
            // const errorHandler = new ErrorHandler(error.response.data.code);
            // errorHandler.showMessage();
            return Promise.reject(error);
        });

        return axiosInstance.request(config);
    }

}

export default ApiSvc;